/**
 * URLs públicas de imágenes de pacientes / HC (small, big, …).
 *
 * En staging el bucket es meducar-media-staging y el CDN es cdn-staging;
 * en prod es meducar-media y cdn.meducar.com.
 * Definir REACT_APP_CDN_MEDIA_URL en el build (ej. https://cdn-staging.meducar.com).
 */
export function getCdnMediaBase() {
  const raw = process.env.REACT_APP_CDN_MEDIA_URL || 'https://cdn.meducar.com';
  return String(raw).replace(/\/$/, '');
}

/**
 * @param {'small' | 'big' | 'medium' | ''} variant  — '' = raíz del CDN media (sin subcarpeta size)
 * @param {string} relativePath  — ej. patient/1-10000/.../file.jpg
 */
export function cdnPatientMedia(variant, relativePath) {
  if (!relativePath) return '';
  const base = getCdnMediaBase();
  const v = variant ? `${variant}/` : '';
  return `${base}/${v}${String(relativePath).replace(/^\//, '')}`;
}

/** Imágenes estáticas bajo /img/ en el mismo CDN media */
export function cdnMediaImgAsset(file) {
  return `${getCdnMediaBase()}/img/${file}`;
}
